import { Button, DialogActions } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { I18n } from 'aws-amplify';
import './CancelDialog.css';
import { onClickConfirmDeleteProject } from './handler/ProjectManagementHandler';

export default function DeleteProjectManagementDialog({ argsAll }) {
    const onCloseDialogReject = (event, reason) => {
        argsAll.setIsOpenConfirmDelete(false);
    };

    return (
        <Dialog
            open={argsAll.isOpenConfirmDelete}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirmPlease">
                    {!argsAll.isProjectCanDelete
                        ? I18n.get('USER03MSG004')
                        : I18n.get('USER03MSG003')}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                {!argsAll.isProjectCanDelete ? (
                    <Button
                        variant="contained"
                        className="btn-hg32 btn-handle-delete-user-agree"
                        onClick={onCloseDialogReject}
                    >
                        閉じる
                    </Button>
                ) : (
                    <>
                        <Button
                            onClick={() =>
                                onClickConfirmDeleteProject(argsAll, argsAll.deleteProject)
                            }
                            variant="contained"
                            className="btn-hg32 btn-handle-delete-user-agree"
                        >
                            {I18n.get('COMBTN002')}
                        </Button>

                        <Button
                            variant="contained"
                            className="btn-light btn-hg32"
                            onClick={onCloseDialogReject}
                        >
                            {I18n.get('COMBTN007')}
                        </Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
    );
}
